<template>
    <div>
        <div class="form-group">
            <label>
                <localized-text localizedKey="Nome" text="Nome"></localized-text>
            </label>
            <input type="text" class="form-control" v-model="localValue.name" />
        </div>
        <div class="form-group">
            <label>
                <localized-text localizedKey="Cognome" text="Cognome"></localized-text>
            </label>
            <input type="text" class="form-control" v-model="localValue.surname" />
        </div>
        <div class="form-group">
            <label>
                <localized-text localizedKey="Nazione di residenza" text="Nazione di residenza"></localized-text>
            </label>
            <select class="form-control" v-model="localValue.country">
                <option :value="'Italy'">
                    {{$localizationService.GetLocalizedValue('Italia', 'Italia')}}
                </option>
                <option :value="'Stato Estero'">
                    {{$localizationService.GetLocalizedValue('Stato Estero', 'Stato Estero')}}
                </option>
            </select>
        </div>
        <attachment-uploader label="Immagine profilo" :canUpload="$route.params.identifier != '0'" v-model="localValue.profilePicture"></attachment-uploader>
    </div>
</template>

<script lang="ts">
import { Prop } from 'vue-property-decorator';
import * as OM from '@/model'
import { mixins, Options, Vue } from 'vue-class-component';
import WithModel from '@/mixins/withModel';

@Options({})
export default class personalData extends mixins(WithModel) {

    declare localValue: OM.PersonalData;
    @Prop() readonly: boolean;

    isMaschio: boolean = false;

}
</script>
<style scoped>
</style>
